import { render, staticRenderFns } from "./TheNav.vue?vue&type=template&id=78513dbe&scoped=true&"
import script from "./TheNav.vue?vue&type=script&lang=js&"
export * from "./TheNav.vue?vue&type=script&lang=js&"
import style0 from "./TheNav.vue?vue&type=style&index=0&id=78513dbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78513dbe",
  null
  
)

/* custom blocks */
import block0 from "./TheNav.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports